<template>
  <v-app>
    <app-bar-component/>
    <transition
        enter-active-class="transition-ease-in-out"
        leave-active-class="transition-ease-in-out">
      <alert-component/>
    </transition>
    <v-main>
      <v-container class="fill-height pa-0 ma-0" fluid>
        <transition
            enter-active-class="transition-ease-in-out"
            leave-active-class="transition-ease-in-out">
          <router-view></router-view>
        </transition>
      </v-container>
    </v-main>
    <v-navigation-drawer
        v-model="show"
        width="310"
        right
        dark
        fixed
        temporary>
      <sidenav-component/>
    </v-navigation-drawer>
    <loading-page-component/>
    <cleaning-dialog/>
  </v-app>
</template>

<script>
export default {
  name: 'App',
  data(){
    return {
    }
  },
  computed: {
    show: {
      get() {
        return this.$store.getters.GET_DRAWER;
      },
      set(value) {
        this.$store.dispatch('setDrawer', value);
      }
    }
  }
};
</script>
